export const Constants = {
  INIT_NODES: 40, // 初始请求节点数
  DOWNLOAD_CONNECTIONS: 16, // 下载同时连接数
  UPLOAD_CONNECTIONS: 4, // 上传同时连接数
  REQUEST_TIMEOUT: 2000, // ms 请求超时
  INTERVAL_TIME: 100, // ms 速度计算间隔
  LOAD_TIME: 10 * 1000, // ms 单行测速时长
  REQUEST_GAP: 100, // ms 请求间隔
  WAITING_TIME: 1000, // ms 预热时间
  STABLE_TIME: 5000, // ms 速度平稳等待的时间
  NEW_DOWNLOAD_COLOR: "#008DFF",
  NEW_UPLOAD_COLOR: "#00FFCB",
  DOWNLOAD_COLOR: "#54AFF0",
  UPLOAD_COLOR: "#E55F25",
  DOWNLOAD_SIZE: 512 * 1024 * 1024, // byte 下载文件大小
  MAX_SPEED: 200,
};

export const DEFAULT_TEXT = "--";
export const SPEED_H5_LINK = "http://speedtest.onethingpcs.com/";
export const SPEED_APP_SCHEME = "otspst://launcher";
export const DEFAULT_FROM = "speed";
